import platform from 'components/Trackers/platform'

export const ScreenViewedEvent = {
  feature: 'Registration Tier Selection Interstitial',
  event_description: 'Screen Viewed',
  platform,
  object: 'Screen',
  action: 'Viewed',
  object_name: 'registrationTierInterstitial',
  style: 'main',
  screen: 'registrationTierInterstitial',
  screen_name: 'registrationTierInterstitial',
}

export const NextButtonTappedEvent = cta_title => {
  return {
    feature: 'Registration Tier Selection Interstitial',
    event_description: 'Next button tapped',
    platform,
    style: 'text',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationTierInterstitialNext',
    screen: 'registrationTierInterstitial',
    screen_name: 'registrationTierInterstitial',
    cta_title: cta_title,
  }
}

export const DisclosureButtonTappedEvent = {
  feature: 'Registration Tier Selection Interstitial',
  event_description: 'More Info button tapped',
  platform,
  object: 'Button',
  action: 'Tapped',
  object_name: 'registrationTierInterstitialMoreInfo',
  screen: 'registrationTierInterstitial',
  screen_name: 'registrationTierInterstitial',
}

export const ScrollBottomEvent = {
  feature: 'Registration Tier Selection Interstitial',
  event_description: 'Screen scrolled to bottom',
  platform,
  object: 'Screen',
  action: 'Viewed',
  object_name: 'registrationFunnelPricingInterstitial',
  screen: 'registrationTierInterstitial',
  screen_name: 'registrationTierInterstitial',
}
